export default import.meta.ROLLDOWN_FILE_URL_dvjAn8NJj8wCzPtk49$E4A